import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'

//UI
import { Box, Flex } from '@chakra-ui/react'
import { MdDragHandle } from 'react-icons/md'

const DraggableItem = ({ id, children }) => {
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id: id })

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  }

  return (
    <Flex ref={setNodeRef} style={style} my={1} alignItems={'center'} gap="2" px="3">
      <Box color="gray.400" {...attributes} {...listeners} _hover={{ cursor: 'grab' }}>
        <MdDragHandle size={25} />
      </Box>
      {children}
    </Flex>
  )
}

export default DraggableItem
